export const MENU_GESCOM_SALES = 'sidebar.gestCom.sales';
export const SOUS_MENU_ECHEANCE_PAIEMENT = 'sidebar.gestCom.echeancePaiement';
export const SOUS_MENU_RETROCESSION = 'sidebar.gestCom.retrocession';
export const MENU_FACTOR = 'sidebar.gestCom.factor';
export const MENU_PRODUITS = 'sidebar.gestCom.produits';
export const SOUS_MENU_PROD_ECRAN_NUM = 'sidebar.gestCom.ecranNum';
export const SOUS_MENU_PLAN_MEDIA = 'sidebar.gestCom.planMedia';
export const MENU_OUTLS = 'sidebar.gestCom.outils';
export const SOUS_MENU_IMPORT_IDELIA = 'sidebar.gestCom.importIdelia';
export const MENU_PRESSE = 'sidebar.gestCom.presse';
export const MENU_PLANNING = 'sidebar.gestCom.planning';
export const SOUS_MENU_PRODUIT_RESEAU_NUM = 'sidebar.gestCom.reseauNum';
export const SOUS_MENU_PRODUIT_FACE_UNITAIRE = 'sidebar.gestCom.faceUnitaire';
export const SOUS_MENU_PRODUIT_RESEAU_LC = 'sidebar.gestCom.reseauLcPlanning';
export const SOUS_MENU_PRODUIT_RESEAU_TEMPO = 'sidebar.gestCom.reseauTempoPlanning';
export const SOUS_MENU_PRODUIT_RESEAU_TEMPO_DISPO = 'sidebar.gestCom.reseauTempoDispo';
export const SOUS_MENU_DEMANDE_TEMPO = 'sidebar.gestCom.demande';
export const MENU_CAMPAGNE = 'sidebar.gestCom.campagne';
export const SOUS_MENU_EDITION_PRODUIT = 'sidebar.gestCom.editionProduit';
export const SOUS_MENU_REGROUPEMENT_PRODUIT = 'sidebar.gestCom.regroupementProduit';
